import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const ChatViewContext = createContext({ isChatView: false, setChatView: () => {} });

const ChatViewProvider = ({ children }) => {
    const [isChatView, setChatView] = useState(false);

    return (
        <ChatViewContext.Provider value={{ isChatView, setChatView }}>
            {children}
        </ChatViewContext.Provider>
    );
};

ChatViewProvider.propTypes = {
    children: PropTypes.any.isRequired
};

const useChatView = () => useContext(ChatViewContext);

export {
    ChatViewProvider,
    useChatView
};
